

























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Subscription } from '@subscriptions/interfaces/subscription';

@Component({
  name: 'bc-suspend-subscription-modal',
  components: {},
})
export default class SuspendSubscriptionModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Object, default: null }) readonly subscription: Subscription;

  // DATA
  loading = false;
  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.$emit('close');
  }

  async suspendSubscription() {
    this.loading = true;
    const url = `${this.$bpcApiRouteHelper.getEntityPath('subscriptions')}/${
      this.subscription.id
    }/suspend`;
    const res = await this.$bpcApi.put(url).toPromise();
    if (res.data) {
      this.$emit('suspended');
    } else {
      this.$bpcMessage.showErrorMessage({ text: 'global.suspend-subscription-error' });
      this.$emit('close-modal');
    }
    this.loading = false;
  }
}
